import React, { useEffect, useState } from "react";
import ApiService from "../Service/ApiService";
import { useNavigate } from "react-router-dom";
import "./Upmenu.css";
import projectData from "../../data/projects.json";
import buildingsData from "../../data/buildings.json";
import newsData from "../../data/news.json";
import jobData from "../../data/staff.json";

const UpMenu = ({ isOpen, onClose, isAlbanian }) => {
  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [animate, setAnimate] = useState(isOpen);
  const [jobs, setJobs] = useState([]);
  const [projects, setProjects] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  const [news, setNews] = useState([]);

  useEffect(() => {
    if (projectData && projectData.length > 0) {
    const shuffledProjects = [...projectData]
      .sort(() => 0.5 - Math.random());
    setProjects(shuffledProjects);
  }

    if (buildingsData && buildingsData.length > 0) {
    const shuffledBuildings = [...buildingsData]
      .sort(() => 0.5 - Math.random());
    setCatalogs(shuffledBuildings);
  }

    if (newsData && newsData.length > 0) {
    const shuffledNews = [...newsData]
      .sort(() => 0.5 - Math.random());
    setNews(shuffledNews);
  }

    if (jobData && jobData.length > 0) {
    const shuffledJobs = [...jobData]
      .sort(() => 0.5 - Math.random());
    setJobs(shuffledJobs);
  }

  }, []);

  const handleMenuToggle = (menu) => {
    setExpandedMenu((prev) => (prev === menu ? null : menu));
  };

  const handleMenuItemClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (isOpen) {
      setAnimate(true);
      document.body.style.overflow = "hidden";
    } else {
      setAnimate(false);
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <div className={`upmenu-container ${isOpen ? "open" : ""}`}>
      <div className="upmenu-overlay" onClick={onClose}></div>
      <div className="vertical-line left"></div>
      <div className="vertical-line right"></div>
      <div className="upmenu-content" onClick={(e) => e.stopPropagation()}>
        <button className="upmenu-close-button" onClick={onClose}>
          &times;
        </button>
        {/* Navigation Section */}
        <div className="upmenu-nav">
          <div class="marquee">
            <span>
              V<span className="small-text">ILA</span>-L&nbsp;{" "}
            </span>
            <span>
              V<span className="small-text">ILA</span>-L&nbsp;{" "}
            </span>
            <span>
              V<span className="small-text">ILA</span>-L&nbsp;{" "}
            </span>
            <span>
              V<span className="small-text">ILA</span>-L&nbsp;{" "}
            </span>
          </div>
        </div>

        {/* Divider Line */}
        <div className="upmenu-divider"></div>

      
        <div className="upmenu-main">
          <ul className="upmenu-items">
            <li
              className={`upmenu-item ${
                expandedMenu === "company" ? "expanded" : ""
              }`}
              onClick={() => handleMenuToggle("company")}
            >
              <span>{isAlbanian ? "Kompania jonë" : "Our Company"}</span>
              <img
                src="/upmenudown.png"
                alt="Up"
                className="upmenudown-button"
              />
            </li>
            {expandedMenu === "company" && (
              <ul className="upmenu-expanded-items visible">
                <li>
                  <a
                    href={`/?targetId=aboutUs`}
                    onClick={(e) => {
                      onClose();
                      e.preventDefault();
                      navigate("/", { state: { targetId: "aboutUs" } });
                    }}
                    target="_self"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {isAlbanian ? "Rreth Nesh" : "About Us"}
                  </a>
                </li>
                <li>
                  <a
                    href={`/?targetId=ourCulture`}
                    onClick={(e) => {
                      onClose();
                      e.preventDefault();
                      navigate("/", { state: { targetId: "ourCulture" } });
                    }}
                    target="_self"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {isAlbanian ? "Vizioni Ynë" : "Our Vision"}
                  </a>
                </li>
                <li>
                  <a
                    href={`/?targetId=ourHistory`}
                    onClick={(e) => {
                      onClose();
                      e.preventDefault();
                      navigate("/", { state: { targetId: "ourHistory" } });
                    }}
                    target="_self"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {isAlbanian ? "Historia Jonë" : "Our History"}
                  </a>
                </li>
                <li>
                  <a
                    href={`/?targetId=ourTeam`}
                    onClick={(e) => {
                      onClose();
                      e.preventDefault();
                      navigate("/", { state: { targetId: "ourTeam" } });
                    }}
                    target="_self"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {isAlbanian ? "Ekipi Ynë" : "Our Team"}
                  </a>
                </li>
              </ul>
            )}

            <li
              className="upmenu-item"
              onClick={() => handleMenuToggle("projects")}
            >
              <span>{isAlbanian ? "Projektet tona" : "Our Projects"}</span>
              <img
                src="/upmenudown.png"
                alt="Up"
                className="upmenudown-button"
              />
            </li>
            {expandedMenu === "projects" && (
              <ul className="upmenu-expanded-items visible">
                {projects.slice(0, 5).map((project) => (
                  <li key={project.project_id}>
                    <a
                      href={`/vilalproject/${project.project_id}`}
                      onClick={(e) => {
                        navigate(`/vilalproject/${project.project_id}`);
                        handleMenuItemClick(e);
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {project.project_title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
            <li
              className="upmenu-item"
              onClick={() => handleMenuToggle("sales")}
            >
              <span>
                {isAlbanian ? "Katalogu i shitjeve" : "Sales catalog"}
              </span>
              <img
                src="/upmenudown.png"
                alt="Up"
                className="upmenudown-button"
              />
            </li>
            {expandedMenu === "sales" && (
              <ul className="upmenu-expanded-items visible">
                {catalogs.slice(0, 5).map((catalog) => (
                  <li key={catalog.building_id}>
                    <a
                      href={`/secondstep/${catalog.building_id}`}
                      onClick={(e) => {
                        navigate(`/secondstep/${catalog.building_id}`);
                        handleMenuItemClick(e);
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {isAlbanian
                        ? catalog.titulli_nderteses
                        : catalog.building_title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
            <li
              className="upmenu-item"
              onClick={() => handleMenuToggle("news")}
            >
              <span>{isAlbanian ? "Lajme" : "News"}</span>
              <img
                src="/upmenudown.png"
                alt="Up"
                className="upmenudown-button"
              />
            </li>
            {expandedMenu === "news" && (
              <ul className="upmenu-expanded-items visible">
                {news.slice(0, 5).map((news) => (
                  <li key={news.news_id}>
                    <a
                      href={`/newsdetails/${news.news_id}`}
                      onClick={(e) => {
                        navigate(`/newsdetails/${news.news_id}`);
                        handleMenuItemClick(e);
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {isAlbanian ? news.titull_lajmesh : news.news_title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
            <li
              className="upmenu-item"
              onClick={() => handleMenuToggle("staff")}
            >
              <span>{isAlbanian ? "Karriera" : "Careers"}</span>
              <img
                src="/upmenudown.png"
                alt="Up"
                className="upmenudown-button"
              />
            </li>
            {expandedMenu === "staff" && (
              <ul className="upmenu-expanded-items visible">
                {jobs.slice(0, 5).map((job) => (
                  <li key={job.staff_id}>
                    <a
                      href={`/jobdetails/${job.staff_id}`}
                      onClick={(e) => {
                        navigate(`/jobdetails/${job.staff_id}`);
                        handleMenuItemClick(e);
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {isAlbanian ? job.titulli_staf : job.staff_tittle}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </ul>
          
        </div>
      

        <div className="upmenu-divider"></div>

        <div className="upmenu-footer">
          <h3>info@vila-l.com</h3>
          <div className="upmenu-social-media-names">
            <li>
              <a
                href="https://www.facebook.com/share/19coQCi7jY/?mibextid=LQQJ4d"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/vilalgroup?igsh=cWR2Nm1qdWlicnly"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/vila-l-sh-p-k/about/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                LinkedIn
              </a>
            </li>
          </div>
          <div className="upmenu-projects-names"></div>
        </div>
      </div>
    </div>
  );
};

export default UpMenu;
